import { titleActions } from '../actionTypes';
import {
  _insertRecord,
} from '../utils';
import createLogger from '../../utils/createLogger';

const DEBUG = true;
const debug = createLogger(DEBUG, `titlesReducer.js`);

/* -------- initial state -------- */
const initialState = {includes_cache: [], categories: [], excludes_cache: [], filter: ``};

export default (state = initialState, action) => {
  switch (action.type) {

    /* -------- titles api -------- */

    /* -------- get titles -------- */
    case titleActions.GET_TITLES_REQUEST:
      return state;

    case titleActions.GET_TITLES_FAILURE:
      return state;

    case titleActions.GET_TITLES_SUCCESS:
      if (action.data) {
        let categories = [...state.categories];
        for (let title of action.data.includes) {
          categories.push(title.category)
        }
        categories = [...new Set(categories)];
        return {...state,
          includes_cache: action.data.includes,
          excludes_cache: action.data.excludes,
          categories: categories};
      }
      return state;


    /* -------- delete title -------- */

    case titleActions.DELETE_TITLE_SUCCESS:
      if (action.data) {
        let newState = {
          ...state,
          includes_cache: state.includes_cache.filter(object => object._id !== action.data),
          excludes_cache: state.excludes_cache.filter(object => object._id !== action.data),
        };

        return newState
      }
      return state;


    /* -------- post title -------- */
    case titleActions.POST_TITLE_SUCCESS:
      if (action.data) {
        if (action.data.exclude === false) {
          return {...state, includes_cache: [...state.includes_cache, {...action.data}]};
        }
        if (action.data.exclude === true) {
          return {...state, excludes_cache: [...state.excludes_cache, {...action.data}]};
        }
      }
      return state;


    /* -------- put title -------- */
    case titleActions.PUT_TITLE_SUCCESS:
      if (action.data) {
        if (action.data.exclude === false) {
          let newState = {...state, includes_cache: [...state.includes_cache]};
          _insertRecord(newState.includes_cache, action.data);
          return newState;
        }
        if (action.data.exclude === true) {
          let newState = {...state, excludes_cache: [...state.excludes_cache]};
          _insertRecord(newState.excludes_cache, action.data);
          return newState;
        }
      }
      return state;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/data/titles/titlesReducer.js